<mat-toolbar class="topbar">

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex d-md-none justify-content-center"
    *ngIf="showToggle">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <div class="d-flex d-md-none justify-content-center ">
    <ng-container *ngIf="!disableLink && !isTempClient; else nonClickableLogo">
      <a [routerLink]="['/']" class="d-flex align-items-center" style="gap: 8px;">
        <img src="./assets/images/logos/base-logo.png" class="align-middle m-2"
          [style.width]="isTempClient ? '100px' : '150px'" alt="logo" />
        <img *ngIf="isTempClient" src="./assets/images/logos/club-beneficios-logo.png" class="align-middle"
          style="width: 100px;" alt="Club de Beneficios TDChile" />
      </a>
    </ng-container>
    <ng-template #nonClickableLogo>
      <div class="d-flex align-items-center" style="gap: 8px;">
        <img src="./assets/images/logos/base-logo.png" class="align-middle m-2"
          [style.width]="isTempClient ? '100px' : '150px'" alt="logo" />
        <img *ngIf="isTempClient" src="./assets/images/logos/club-beneficios-logo.png" class="align-middle"
          style="width: 100px;" alt="Club de Beneficios TDChile" />
      </div>
    </ng-template>
  </div>

  <!-- Botón del menú para web -->
  <button mat-icon-button (click)="toggleWebNav.emit()" class="sidebar-toggle desktop-sidebar-toggle" aria-label="Contraer menú">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- Notification Bell -->
  <button mat-icon-button class="notification-toggle" aria-label="Notificaciones" [matMenuTriggerFor]="notificationMenu" *ngIf="isLoggedIn">
    <i-tabler class="d-flex" name="bell" [matBadge]="unreadCount > 0 ? unreadCount : null" matBadgeColor="warn"
      [matBadgeHidden]="unreadCount === 0"></i-tabler>
  </button>

  <mat-menu #notificationMenu="matMenu" xPosition="after" yPosition="below" class="cardWithShadow">
    <div class="px-3 pt-3 pb-2 border-bottom">
      <h6 class="m-0 fw-semibold fs-4">Avisos de Renovación</h6>
      <span class="text-muted fs-12">Tarjetas próximas a expirar en 30 días o menos</span>
    </div>
    <ng-scrollbar style="height: 380px; max-width: 380px;">
      <div *ngIf="expiringCards.length === 0" class="p-4 text-center text-muted">
        <i-tabler name="bell-off" class="icon-30 mb-2"></i-tabler>
        <p class="mb-0 fs-14">No hay notificaciones de vencimiento.</p>
      </div>

      <!-- Tarjetas Expiradas -->
      <div *ngIf="expiredCards.length > 0" class="px-3 pt-3 pb-2 bg-light">
        <span class="text-danger fw-bold text-uppercase fs-12" style="letter-spacing: 1px;">Tarjetas Expiradas</span>
      </div>
      <button mat-menu-item *ngFor="let card of expiredCards" [routerLink]="['/admin/billing/detail', card.idCliente]"
        class="px-3 py-3 border-bottom" style="height: auto; line-height: normal; white-space: normal;">
        <div class="d-flex align-items-center">
          <div class="bg-light-danger text-danger rounded-circle d-flex align-items-center justify-content-center me-3"
            style="width: 44px; height: 44px; flex-shrink: 0;">
            <i-tabler name="calendar-off" class="icon-20"></i-tabler>
          </div>
          <div>
            <h6 class="mb-1 text-dark fw-bold fs-14">{{ card.org }}</h6>
            <span class="d-flex align-items-center text-danger fw-semibold mt-1 fs-12">
              Suscripción vencida el {{ card.endDate | date:'dd MMM yyyy' }}
            </span>
          </div>
        </div>
      </button>

      <!-- Tarjetas por Expirar -->
      <div *ngIf="expiringSoonCards.length > 0" class="px-3 pt-3 pb-2 bg-light border-bottom">
        <span class="text-warning fw-bold text-uppercase fs-12"
          style="color: #ff9800 !important; letter-spacing: 1px;">Próximas a Expirar</span>
      </div>
      <button mat-menu-item *ngFor="let card of expiringSoonCards"
        [routerLink]="['/admin/billing/detail', card.idCliente]" class="px-3 py-3 border-bottom"
        style="height: auto; line-height: normal; white-space: normal;">
        <div class="d-flex align-items-center">
          <div
            class="bg-light-warning text-warning rounded-circle d-flex align-items-center justify-content-center me-3"
            style="width: 44px; height: 44px; flex-shrink: 0;">
            <i-tabler name="clock-hour-4" class="icon-20"></i-tabler>
          </div>
          <div>
            <h6 class="mb-1 text-dark fw-bold fs-14">{{ card.org }}</h6>
            <span class="d-flex align-items-center text-warning fw-semibold mt-1 fs-12"
              style="color: #ff9800 !important;">
              Expira en {{ card.daysRemaining }} días - {{ card.endDate | date:'dd MMM' }}
            </span>
          </div>
        </div>
      </button>

    </ng-scrollbar>
  </mat-menu>


  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->

  <button class="m-l-10" *ngIf="isLoggedIn" mat-icon-button [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications">
    <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" xPosition="before" class="cardWithShadow">
    <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>
      Mis Datos
    </button>
    <!-- <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="mail" class="icon-18 d-flex"></i-tabler></mat-icon>My
      Account
    </button>
    <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="list-check"
          class="icon-18 d-flex"></i-tabler></mat-icon>My Task
    </button> -->

    <div class="p-x-12 m-t-12">
      <a (click)="logout()" mat-stroked-button color="primary" class="w-100">Cerrar Session</a>
    </div>

  </mat-menu>

  <div class="p-x-12 m-t-12" *ngIf="!isLoggedIn">
    <a (click)="login()" mat-stroked-button color="primary" class="w-100"
      style="padding: 0px;min-width: 50px;">Login</a>
  </div>
</mat-toolbar>
